import axios from "axios";
import { baseUrl } from "../../../../../apis/util";

/**
 * Impact category keys — must match HeaderBox RightBox IMPACT_CATEGORIES.
 * Flow 33 total = sum of rows across 33.1 (manufacturing processes) and 33.2 (by-products).
 */
const IMPACT_KEYS = [
  "global_warming",
  "ozone_depletion",
  "smog",
  "acidification",
  "eutrophication_terrestrial",
  "eutrophication_freshwater",
  "eutrophication_marine",
  "carcinogenics",
  "non_carcinogenics",
  "respiratory_effects",
  "ecotoxicity",
  "fossil_fuel_depletion",
  "land_use",
  "water_use",
  "resource_use_minerals_metals",
  "ionising_radiation",
];

function impactValueFromRow(row, key) {
  const raw =
    row[key] ??
    row[`impact_${key}`] ??
    row.impact_categories?.[key];
  const n = Number(raw);
  return Number.isFinite(n) ? n : 0;
}

function sumImpactTotalsFromRows(rows) {
  const totals = {};
  IMPACT_KEYS.forEach((k) => {
    totals[k] = 0;
  });
  (rows || []).forEach((row) => {
    IMPACT_KEYS.forEach((k) => {
      totals[k] += impactValueFromRow(row, k);
    });
  });
  return totals;
}

function authHeaders() {
  return {
    Authorization: "Bearer " + localStorage.getItem("access_token"),
    "Content-Type": "application/json",
  };
}

async function getDataArray(url) {
  try {
    const response = await axios({
      method: "get",
      url,
      headers: authHeaders(),
    });
    const data = response.data?.data;
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
}

/**
 * Fetches LCA row data for Flow 33.1 and 33.2 and returns summed impact totals (client-side).
 */
export async function fetchFlow33AggregatedImpactTotals(productId) {
  if (!productId) {
    return null;
  }

  const base = `${baseUrl}/api/business/product/${productId}`;

  const [flow33_1, flow33_2] = await Promise.all([
    getDataArray(`${base}/manufacturing-processes-33-1-lca`),
    getDataArray(`${base}/manufacturing-by-products-33-2-lca`),
  ]);

  const allRows = [...flow33_1, ...flow33_2];

  return sumImpactTotalsFromRows(allRows);
}
